import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { BenefitsSection } from "@/components/BenefitsSection";
import { ServicesSection } from "@/components/ServicesSection";
import { HowItWorksSection } from "@/components/HowItWorksSection";
import { FAQSection } from "@/components/FAQSection";
import { CTASection } from "@/components/CTASection";
import { DemoIncludesSection } from "@/components/DemoIncludesSection";
import { AdvancedAutomationsSection } from "@/components/AdvancedAutomationsSection";
import { ContactSection } from "@/components/ContactSection";
import { ChatWidget } from "@/components/ChatWidget";
import { Footer } from "@/components/Footer";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <BenefitsSection />
        <ServicesSection />
        <HowItWorksSection />
        <FAQSection />
        <DemoIncludesSection />
        <AdvancedAutomationsSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
